import type { LanguageCode } from "common/types/languageCode";
import type { PayloadTerm } from "domains/language/types";

export enum LanguageDomainActionType {
  FETCH = "domains/LANGUAGE_FETCH_TERMS",
  FETCH_FULFILLED = "domains/LANGUAGE_FETCH_TERMS_SUCCESS",
  FETCH_REJECTED = "domains/LANGUAGE_FETCH_TERMS_FAILURE",
}

export type FetchLanguageTermsDefaultAction = {
  meta: { language: LanguageCode; initialising?: boolean };
  type: LanguageDomainActionType.FETCH;
};

export type FetchLanguageTermsFulfilledAction = {
  meta: { language: LanguageCode };
  payload: { terms: readonly PayloadTerm[] };
  type: LanguageDomainActionType.FETCH_FULFILLED;
};

export type FetchLanguageTermsRejectedAction = { type: LanguageDomainActionType.FETCH_REJECTED };

export type FetchLanguageAction =
  | FetchLanguageTermsDefaultAction
  | FetchLanguageTermsFulfilledAction
  | FetchLanguageTermsRejectedAction;
